import { render } from "./yi-fc3d.vue?vue&type=template&id=02cf2b36&scoped=true"
import script from "./yi-fc3d.vue?vue&type=script&lang=js"
export * from "./yi-fc3d.vue?vue&type=script&lang=js"

import "./yi-fc3d.vue?vue&type=style&index=0&id=02cf2b36&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02cf2b36"]])

export default __exports__